import { Directive } from '@angular/core';
import { GtmTrackSelectItemDirective as GtmTrackSelectItemCore } from '@df/module-gtm/track/select-item/gtm-track-select-item.directive';

@Directive({
    selector: '[gtmTrackSelectItem]',
    standalone: true
})
export class GtmTrackSelectItemDirective extends GtmTrackSelectItemCore {}
